var map = {
	"./bannerLogo_americas.png": 6834,
	"./bannerLogo_canada.png": 1906,
	"./bannerLogo_champions.png": 5828,
	"./bannerLogo_forme.png": 3736,
	"./bannerLogo_kornferry.png": 8999,
	"./bannerLogo_latinoamerica.png": 1193,
	"./bannerLogo_mackenzie.png": 7334,
	"./bannerLogo_mental_health.png": 9452,
	"./bannerLogo_pga.png": 2253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1076;